import React, { useState, useRef } from "react";
import {
  withSitecoreContext,
} from "@sitecore-jss/sitecore-jss-react";

import "./index.scss";
import { PrivacyFilterModel } from "./models/PrivacyFilter.model";
import { PrivacyFilterProps } from "./types/PrivacyFilter.types";
import LazySection from "../../react-only-components/LazySection";

const PrivacyFilter = (props: PrivacyFilterProps) => {
  const selectBrand = useRef<HTMLSelectElement>(null)
  const selectLocal = useRef<HTMLSelectElement>(null)
  const filterBtn = useRef<HTMLAnchorElement>(null)
  const model = new PrivacyFilterModel(props);
  let filterButtonSubmit = filterBtn?.current;

  let defdaultHref = model?.submitButtonLink?.value?.href
  const [newUrl, setNewUrl] = useState("");
  const leftFilterChange = (event) => {
    let leftFilterUrl = `${defdaultHref}?brand=${event?.target?.value}&lang=${selectLocal?.current?.value ?? ''}`
    setNewUrl(leftFilterUrl)
    filterButtonSubmit?.setAttribute("href", `${leftFilterUrl}`)
  }

  const rightFilterChange = (event) => {
    let rightFilterUrl = `${defdaultHref}?brand=${selectBrand?.current?.value}&lang=${event?.target?.value}`
    setNewUrl(rightFilterUrl)
    filterButtonSubmit?.setAttribute("href", `${rightFilterUrl}`)
  }

  return (
    <LazySection>
      {props?.fields && (
        <div className="privacy-filter">
          <div className="left-filter-section">
            <div className="left-label-filter">
              {model?.leftFilterLabel?.value}:
            </div>
            <select className="left-selectbox-filter" onChange={leftFilterChange} ref={selectBrand} >
              <option>
                {model?.placeholder?.value}
              </option>
              {props?.fields?.LeftFilterValues?.map((item) => (
                <option>
                  {item?.fields?.Key?.value}
                </option>
              ))}
            </select>
          </div>
          <div className="right-filter-section">
            <div className="right-label-filter">
              {model?.rightFilterLabel?.value}:
            </div>
            <select className="right-selectbox-filter" onChange={rightFilterChange} ref={selectLocal}>
              <option>
                {model?.placeholder?.value}
              </option>
              {props?.fields?.RightFilterValues?.map((item) => (
                <option>
                  {item?.fields?.Key?.value}
                </option>
              ))}
            </select>
          </div>
          <div className="filter-submit-button">
            <a href={model?.submitButtonLink?.value?.href} ref={filterBtn}> {model?.submitButtonLink?.value?.text}</a>
          </div>
        </div>
      )}
    </LazySection>
  );
};

export default withSitecoreContext()(PrivacyFilter);
